import React, { useState } from "react";
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import IconMenu from "../../components/subMenu/SubMenu";
import { IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { Routes, Route, useParams, useLocation } from "react-router-dom";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Pdf from "../../components/pdf/Pdf";
import { PDFBoxer } from "@react-pdf/renderer";
import useSave from "../../Hooks/useSave";
import { Page, Document, StyleSheet, Image } from "@react-pdf/renderer";
import { useEffect } from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Popover from "../../components/Popover/Popover";
import PreviewIcon from "@mui/icons-material/Preview";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: "50px",
  },
  header: {
    fontSize: "24",
    display: "flex",
    flexDirection: "row",
    // margin: "0px 50px 10px 50px",
    borderBottom: "2pt solid black",
  },
  words: {
    margin: "5px",
  },
  word1: {
    margin: "5px",
    marginRight: "45px",
    width: "70%",
  },
  word2: {
    margin: "5px",
    width: "10%",
    TypographyAlign: "right",
  },
  word3: {
    margin: "5px",
    width: "20%",
  },
  word4: {
    margin: "5px",
    width: "70%",
  },
  section: {
    borderBottom: "1pt dashed black",
    margin: "0px 20px",
    paddingBottom: "5px",
    display: "flex",
    flexDirection: "column",
  },
  section2: {
    fontSize: "14",
    // margin: "0px 52px",
    display: "flex",
    flexDirection: "row",
  },
  item1: {
    marginLeft: "25px",
    fontSize: "12",
    fontWeight: "200",
    width: "250px",
  },
  item2: {
    marginLeft: "25px",
    fontSize: "12",
    width: "30px",
    fontWeight: "200",
    TypographyAlign: "right",
  },
  item3: {
    marginLeft: "5px",
    fontSize: "12",
    width: "90px",
    fontWeight: "200",
  },
});

const menuHeader = {
  icon: <SettingsOutlinedIcon sx={{ color: "white" }} fontSize="small" />,
  name: "Reports",
};

function sortByThenBy(a, b, thenBy, order) {
  if (order === "asc" || !order) {
    if (!a && !b) return thenBy || 0;
    if (!a) return -1;
    if (!b) return +1;

    return a.localeCompare(b) || thenBy || 0;
  } else if (order === "desc") {
    if (!a && !b) return thenBy || 0;
    if (!a) return +1;
    if (!b) return -1;

    return b.localeCompare(a) || thenBy || 0;
  }
}

function InteractiveReports({ fromDate, done }) {
  const [orderedProducts, setOrderedProducts] = useState();
  const { fetchGraphql, DialogSave } = useSave();
  const [data, setData] = useState([]);
  const [productProductionSheets, setProductProductionSheets] = useState([]);
  const { sheet } = useParams();
  const location = useLocation();
  const [productOrders, setProductOrders] = useState([]);
  const [hidePopover, setHidePopover] = useState(false);

  const filterPopoverExit = () => {
    setHidePopover(false);
    // this.setActiveIcon();
  };

  const menu = productProductionSheets.map((item) => ({
    link: `/reports/${item}`,
    name: item,
  }));

  useEffect(() => {
    fetchGraphql({
      query: `
        query productProductionSheets {
          productProductionSheets
        }`,
    }).then((result) => {
      setProductProductionSheets(result.data.productProductionSheets);
    });
  }, []);

  //create date
  const date = new Date();
  const tomorow = new Date(date);
  tomorow.setDate(date.getDate() + 1);

  // const [fromDate, setFromDate] = useState(tomorow.toDateString());

  const groupBy = (items, key) =>
    items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );

  useEffect(() => {
    fetchGraphql({
      query: `query OrderedProducts($deliveryDate: String, $productionSheet: String, $orderStatus: [String]) {
        orderedProducts(deliveryDate: $deliveryDate, productionSheet: $productionSheet, orderStatus: $orderStatus) {
          unitOfMeasure
          quantity
          groupQuantity
          productName
          productCategory
          productSubCategory
          groupCode
          groupName
          productId
          groupUnitOfMeasure
        }
      }`,
      variables: {
        deliveryDate: fromDate,
        productionSheet: sheet,
        orderStatus: done ? ["Done", "Submited"] : ["Submited"],
      },
    }).then((result) => {
      const items = result.data.orderedProducts.map((item, index) => {
        if (!item.groupCode) {
          return { ...item, groupCode: index };
        } else {
          return { ...item };
        }
      });

      const groupedItems = groupBy(items, "groupCode");

      // console.log(result, groupedItems);

      setOrderedProducts(groupedItems);
    });
  }, [fromDate, location, done]);

  try {
    return (
      <Box width="900px" height="100%">
        <Paper>
          <Box size="LETTER" style={styles.page}>
            <Box fixed style={styles.header}>
              <Typography style={styles.words}>{sheet + "s Report"}</Typography>

              <Typography
                style={{
                  fontSize: "12",
                  marginLeft: "20px",
                  paddingTop: "20px",
                }}
              >
                {fromDate}
              </Typography>
            </Box>

            {orderedProducts
              ? Object.keys(orderedProducts)
                  .sort((a, b) => {
                    return sortByThenBy(
                      orderedProducts[a][0].productCategory,
                      orderedProducts[b][0].productCategory,
                      sortByThenBy(
                        orderedProducts[a][0].productSubCategory,
                        orderedProducts[b][0].productSubCategory,
                        sortByThenBy(
                          orderedProducts[a][0].productName,
                          orderedProducts[b][0].productName
                        )
                      )
                    );
                  })
                  .map((key) => {
                    // console.log(orderedProducts[key]);
                    return (
                      <>
                        <Box style={styles.section} wrap={false}>
                          <Box style={styles.section2}>
                            {!orderedProducts[key][0].groupName && (
                              <Popover
                                refExit={filterPopoverExit}
                                hide={hidePopover}
                                classes={{
                                  closeIcon: null,
                                }}
                                trigger={
                                  <Tooltip
                                    title="Priview Order"
                                    disableFocusListener
                                  >
                                    <IconButton
                                      onClick={(e) => {
                                        fetchGraphql({
                                          query: `query ProductOrders($productId: ID, $deliveryDate: String, $orderStatus: [String]) {
                                            productOrders(productId: $productId, deliveryDate: $deliveryDate, orderStatus: $orderStatus) {
                                              orderId
                                              customerName
                                              quantity
                                            }
                                          }`,
                                          variables: {
                                            productId:
                                              orderedProducts[key][0].productId,
                                            deliveryDate: fromDate,
                                            orderStatus: done
                                              ? ["Done", "Submited"]
                                              : ["Submited"],
                                          },
                                        }).then((result) => {
                                          setProductOrders(
                                            result.data.productOrders
                                          );
                                        });
                                      }}
                                    >
                                      <PreviewIcon />
                                    </IconButton>
                                  </Tooltip>
                                }
                                content={
                                  <Box
                                    onClick={(e) => e.stopPropagation()}
                                    sx={{
                                      margin: "20px",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    {orderedProducts[key][0].productName}
                                    <Box
                                      sx={{
                                        display: "grid",
                                        gridTemplateColumns: "2fr 7fr 2fr",
                                        columnGap: "10px",
                                      }}
                                    >
                                      <Box>
                                        <b>order id</b>
                                      </Box>
                                      <Box>
                                        <b>Customer Name</b>
                                      </Box>
                                      <Box>
                                        <b>Quantity</b>
                                      </Box>
                                      {productOrders?.map((item) => (
                                        <>
                                          <Box>{item.orderId}</Box>
                                          <Box>{item.customerName}</Box>
                                          <Box>{item.quantity}</Box>
                                        </>
                                      ))}
                                    </Box>
                                  </Box>
                                }
                                anchorOrigin={{
                                  vertical: "center",
                                  horizontal: "left",
                                }}
                                transformOrigin={{
                                  vertical: "center",
                                  horizontal: "right",
                                }}
                              />
                            )}
                            <Typography
                              style={
                                orderedProducts[key][0].groupName
                                  ? styles.word1
                                  : styles.word4
                              }
                            >
                              {orderedProducts[key][0].groupName ||
                                orderedProducts[key][0].productName}
                            </Typography>
                            <Typography style={styles.word2}>
                              {orderedProducts[key][0]?.groupName
                                ? orderedProducts[key][0]?.groupQuantity
                                : orderedProducts[key][0]?.quantity}
                            </Typography>
                            <Typography style={styles.word3}>
                              {`${
                                orderedProducts[key][0].groupUnitOfMeasure ||
                                orderedProducts[key][0].unitOfMeasure
                              }'s`}
                            </Typography>
                          </Box>
                          {orderedProducts[key][0].groupName
                            ? orderedProducts[key].map((item) => (
                                <Box style={styles.section2}>
                                  <Popover
                                    refExit={filterPopoverExit}
                                    hide={hidePopover}
                                    classes={{
                                      closeIcon: null,
                                    }}
                                    trigger={
                                      <Tooltip
                                        title="Priview Order"
                                        disableFocusListener
                                      >
                                        <IconButton
                                          onClick={(e) => {
                                            fetchGraphql({
                                              query: `query ProductOrders($productId: ID, $deliveryDate: String, $orderStatus: [String]) {
                                            productOrders(productId: $productId, deliveryDate: $deliveryDate, orderStatus: $orderStatus) {
                                              orderId
                                              customerName
                                              quantity
                                            }
                                          }`,
                                              variables: {
                                                productId: item.productId,
                                                deliveryDate: fromDate,
                                                orderStatus: done
                                                  ? ["Done", "Submited"]
                                                  : ["Submited"],
                                              },
                                            }).then((result) => {
                                              setProductOrders(
                                                result.data.productOrders
                                              );
                                            });
                                          }}
                                        >
                                          <PreviewIcon />
                                        </IconButton>
                                      </Tooltip>
                                    }
                                    content={
                                      <Box
                                        onClick={(e) => e.stopPropagation()}
                                        sx={{
                                          margin: "20px",
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        {item.productName}
                                        <Box
                                          sx={{
                                            display: "grid",
                                            gridTemplateColumns: "2fr 7fr 2fr",
                                            columnGap: "10px",
                                          }}
                                        >
                                          <Box>
                                            <b>order id</b>
                                          </Box>
                                          <Box>
                                            <b>Customer Name</b>
                                          </Box>
                                          <Box>
                                            <b>Quantity</b>
                                          </Box>
                                          {productOrders?.map((item) => (
                                            <>
                                              <Box>{item.orderId}</Box>
                                              <Box>{item.customerName}</Box>
                                              <Box>{item.quantity}</Box>
                                            </>
                                          ))}
                                        </Box>
                                      </Box>
                                    }
                                    anchorOrigin={{
                                      vertical: "center",
                                      horizontal: "left",
                                    }}
                                    transformOrigin={{
                                      vertical: "center",
                                      horizontal: "right",
                                    }}
                                  />
                                  <Typography style={styles.item1}>
                                    {item.productName}
                                  </Typography>

                                  <Typography style={styles.item2}>
                                    {item.quantity}
                                  </Typography>

                                  <Typography style={styles.item3}>
                                    {`${item.unitOfMeasure}s`}
                                  </Typography>
                                </Box>
                              ))
                            : null}
                        </Box>
                      </>
                      // </Box>
                    );
                  })
              : null}
          </Box>
        </Paper>
      </Box>
    );
  } catch (error) {
    console.log(error);
  }
}

export default InteractiveReports;
